export default [
    {
        "name": "酒店整体情况",
        "sort": 0,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "本年度经营月份",
        "sort": 1,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "本月实际经营天数",
        "sort": 2,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Total Staff Number 本月员工总数 （包含实习生，不包含临时工)",
        "sort": 3,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "客房部",
        "sort": 4,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Rooms Staff 客房部员工总数 (包括前台)",
        "sort": 5,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Rooms Labor Cost 客房部门人力成本（包含工资及福利费用合计，不含劳务外包及帮工费用）",
        "sort": 6,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Rooms Total Salary 客房部门员工工资（仅工资）",
        "sort": 7,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "餐饮部",
        "sort": 8,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "F&B Staff 餐饮部员工总数",
        "sort": 9,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "F&B Labor Cost 餐饮部门人力成本（包含工资及福利费用合计，不含劳务外包及帮工费用）",
        "sort": 10,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "F&B Total Salary 餐饮部门员工工资（仅工资）",
        "sort": 11,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "其他营业部门",
        "sort": 12,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Other Operating Staff 其他营业部门员工总数",
        "sort": 13,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Other Operating Labor Cost 其他营业部门人力成本",
        "sort": 14,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Other Operating Salary 其他营业部门员工工资 (仅工资)",
        "sort": 15,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "后台部门",
        "sort": 16,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Undistributed Staff 后台部门员工总数",
        "sort": 17,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Undistributed Labor Cost 后台部门人力成本",
        "sort": 18,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Undistributed Salary 后台部门员工工资 (仅工资)",
        "sort": 19,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "实习生",
        "sort": 20,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Trainee 总实习生人数",
        "sort": 21,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Trainee Cost 总培训生费用支出 - 工资",
        "sort": 22,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Trainee Cost 总培训生费用支出 - 管理费 ",
        "sort": 23,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "人效指数",
        "sort": 24,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "酒店整体人效指数",
        "sort": 25,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "F&B人效指数",
        "sort": 26,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Rooms人效指数",
        "sort": 27,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "劳动生产率",
        "sort": 28,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "F&B劳动生产率",
        "sort": 29,
        "actual": 0,
        "last": 0,
        "contrast": 0
    },
    {
        "name": "Rooms劳动生产率",
        "sort": 30,
        "actual": 0,
        "last": 0,
        "contrast": 0
    }
]


// WEBPACK FOOTER //
// ./src/components/table/7-HumanResourcesAnalysis/7-7/data.js